document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".maple_section_custom .block_text");

  function applyBehavior() {
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;

    blocks.forEach((block) => {
      const title = block.querySelector("h4");
      const description = block.querySelector("p");

      // Réinitialiser les styles
      description.style.transition = "max-height 0.5s ease-out, opacity 0.5s";
      description.style.overflow = "hidden";
      description.style.opacity = 0;
      description.style.maxHeight = "0px";

      // Supprimer tous les anciens écouteurs en clonant l'élément
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      if (isDesktop) {
        // Sur desktop (≥ 768px) : opacité au survol
        description.style.maxHeight = ""; // Reset max-height pour éviter les conflits

        newTitle.addEventListener("mouseenter", function () {
          description.style.opacity = 1;
        });

        newTitle.addEventListener("mouseleave", function () {
          description.style.opacity = 0;
        });
      } else {
        // Sur mobile (≤ 767px) : effet "expand" au clic
        newTitle.addEventListener("click", function () {
          if (description.style.maxHeight === "0px") {
            description.style.maxHeight = description.scrollHeight + "px";
            description.style.opacity = 1;
          } else {
            description.style.maxHeight = "0px";
            description.style.opacity = 0;
          }
        });
      }
    });
  }

  applyBehavior(); // Appliquer le comportement au chargement
  window.addEventListener("resize", applyBehavior); // Re-appliquer si la taille change

  // Remove Case format dropdown on Product Recommandations slider
  const product_template = document.querySelector("product-variant-provider");
  if (product_template) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const addedNodes = Array.from(mutation.addedNodes);

          // Trouver TOUS les éléments avec la classe `product-card`
          const foundElements = addedNodes.filter(
            (node) => node.classList && node.classList.contains("#product-card")
          );

          if (foundElements.length > 0) {
            foundElements.forEach((element) => {
              const selectElement = element.querySelector(
                'select[name="Case format"]'
              );
              if (selectElement) {
                selectElement.parentElement.style.display = "none";
              }
            });
            observer.disconnect();
          }
        }
      });
    });

    // Observer les changements dans tout le document
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Contact Form Validation
  const contactFormSubmiter = document.querySelector("contact-form-submiter");
  if (contactFormSubmiter) {
    const form = contactFormSubmiter.querySelector("form");
    const formFields = [...form.getElementsByClassName("#form-field")];
    const submitBtn = form.querySelector("button[type=submit]");

    const requiredFields = [
      { selector: 'input[name="contact[Name]"]', type: "text" },
      { selector: 'input[name="contact[Nom]"]', type: "text" },
      { selector: 'input[name="contact[email]"]', type: "email" },
      { selector: 'textarea[name="contact[Message]"]', type: "textarea" },
    ];

    form.setAttribute("novalidate", true);
    submitBtn.addEventListener("click", validateForm);

    function validateForm(e) {
      e.preventDefault();
      let isValid = true;

      // Nettoyer toutes les erreurs précédentes
      formFields.forEach((field) => {
        field.classList.remove("has-error");
        const errorEl = field.querySelector(".form-error");
        if (errorEl) errorEl.remove();
      });

      requiredFields.forEach((field) => {
        const input = form.querySelector(field.selector);
        if (!input) return;

        const value = input.value.trim();
        const parent = input.parentNode;

        const errorMessage =
          input.getAttribute("data-error-message") || "This field is required.";
        const emailErrorMessage =
          input.getAttribute("data-email-error") ||
          "Please enter a valid email address.";
        let hasError = false;

        if (
          value === "" ||
          (field.type === "email" && !/^\S+@\S+\.\S+$/.test(value))
        ) {
          hasError = true;
        }

        if (hasError && parent) {
          parent.classList.add("has-error");

          // Crée un élément d'erreur
          const errorEl = document.createElement("div");
          errorEl.className = "form-error";
          errorEl.textContent = errorMessage;
          if (field.type === "email") {
            errorEl.textContent += emailErrorMessage;
          }
          parent.appendChild(errorEl);

          isValid = false;
        }

        // Ajouter le listener pour valider en direct
        input.addEventListener("input", () => {
          const parent =
            input.parentNode || input.closest('[class~="#form-field"]');
          if (input.checkValidity()) {
            input.classList.remove("field-error");
            parent?.classList.remove("has-error");

            // Supprimer le message d'erreur s'il existe
            const existingMessage = parent?.querySelector(".form-error");
            if (existingMessage) {
              existingMessage.remove();
            }
          }
        });
      });

      if (!isValid) {
        e.preventDefault(); // Empêche l’envoi
        return;
      }

      // Soumission manuelle si valide
      e.preventDefault();
      form.removeAttribute("novalidate");
      form.submit();
    }
  }
});
